import { Action, createReducer, on } from '@ngrx/store';
import * as errorActions from './error.actions';
import * as authActions from '../auth/auth.actions';
import { ErrorState } from './error.state';

export const initialError: ErrorState = {
  message: '',
  show: false,
  errorType: null,
  errorComponentData: null,
  isLoading: true,
  countResendOTPCode: 0,
};

const _errorReducer = createReducer(
  initialError,
  on(errorActions.handleError, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(errorActions.showError, (state, { message, errorType }) => {
    return {
      ...state,
      message,
      show: true,
      errorType,
      errorComponentData: null,
      isLoading: false,
    };
  }),
  on(errorActions.showErrorComponent, (state, { errorComponentData }) => {
    return {
      ...state,
      errorComponentData,
      isLoading: false,
    };
  }),
  on(errorActions.clearError, (state) => {
    return {
      ...state,
      initialError,
    };
  }),
  on(authActions.requestLoginCode, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(authActions.successRequestLoginCode, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(authActions.failureRequestLoginCode, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(errorActions.setCountResendOTPCode, (state, { countResendOTPCode }) => {
    return {
      ...state,
      countResendOTPCode,
    };
  }),
  on(errorActions.increaseCountResendOTPCode, (state) => {
    return {
      ...state,
      countResendOTPCode: state.countResendOTPCode + 1,
    };
  })
);

export function ErrorReducers(state: ErrorState | undefined, action: Action) {
  return _errorReducer(state, action);
}
